var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-container"},[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("The resource you were looking for cannot be found")]),_c('b-button-group',[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.goBack}},[_vm._v("Back")]),_c('b-button',{attrs:{"to":"/","variant":"danger"}},[_vm._v("Home")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }